import { render, staticRenderFns } from "./ClientsList.vue?vue&type=template&id=359009eb&scoped=true&"
import script from "./ClientsList.vue?vue&type=script&lang=js&"
export * from "./ClientsList.vue?vue&type=script&lang=js&"
import style0 from "./ClientsList.vue?vue&type=style&index=0&id=359009eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359009eb",
  null
  
)

export default component.exports